import React, { useState } from "react";
import { useStudio } from "../store/useStudio";

const backdrop = { position: "fixed", inset: 0, background: "rgba(15,18,22,0.55)", backdropFilter: "blur(6px)", zIndex: 4000, display: "flex", alignItems: "center", justifyContent: "center", padding: 20 };
const card = { width: 440, maxWidth: "100%", background: "#fff", borderRadius: 16, padding: "24px 26px", boxShadow: "0 24px 60px rgba(0,0,0,0.3)" };
const label = { fontSize: 11, fontWeight: 700, letterSpacing: 0.4, textTransform: "uppercase", color: "#86868B", marginBottom: 6, display: "block" };
const input = { width: "100%", padding: "10px 12px", borderRadius: 9, border: "1px solid #e3e6ea", fontSize: 14, outline: "none", marginBottom: 16 };
const btn = { padding: "9px 16px", borderRadius: 999, border: "none", fontSize: 13, fontWeight: 600, cursor: "pointer" };

export default function ReportDetailsModal({ open, onClose }) {
  const reportMeta = useStudio((s) => s.reportMeta);
  const setReportMeta = useStudio((s) => s.setReportMeta);
  const [coverTitle, setCoverTitle] = useState(reportMeta.coverTitle || "");
  const [clientName, setClientName] = useState(reportMeta.clientName || "");
  const [logo, setLogo] = useState(reportMeta.logo || null);
  const [includeCosting, setIncludeCosting] = useState(reportMeta.includeCosting !== false);
  const [err, setErr] = useState("");

  if (!open) return null;

  const onLogo = (e) => {
    const f = e.target.files?.[0];
    if (!f) return;
    if (!/image\/(png|jpe?g|webp|svg\+xml)/.test(f.type)) { setErr("Use a PNG, JPG, WEBP or SVG image."); return; }
    if (f.size > 1.5 * 1024 * 1024) { setErr("Logo must be under 1.5 MB."); return; }
    const reader = new FileReader();
    reader.onload = () => { setLogo(reader.result); setErr(""); };
    reader.readAsDataURL(f);
  };

  const save = () => {
    setReportMeta({ coverTitle: coverTitle.trim(), clientName: clientName.trim(), logo, includeCosting });
    onClose();
  };

  return (
    <div style={backdrop} onClick={onClose} data-testid="report-details-modal">
      <div style={card} onClick={(e) => e.stopPropagation()}>
        <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 4 }}>Report details</div>
        <div style={{ fontSize: 12.5, color: "#86868B", marginBottom: 18 }}>These appear on the PDF cover so it's client-ready.</div>

        <label style={label}>Cover title</label>
        <input style={input} value={coverTitle} onChange={(e) => setCoverTitle(e.target.value)} placeholder="e.g. Riverside Tower — BIA Feasibility" data-testid="report-cover-title" />

        <label style={label}>Client name</label>
        <input style={input} value={clientName} onChange={(e) => setClientName(e.target.value)} placeholder="Prepared for…" data-testid="report-client-name" />

        <label style={label}>Studio logo</label>
        <div style={{ display: "flex", alignItems: "center", gap: 14, marginBottom: 8 }}>
          {logo ? <img src={logo} alt="logo" style={{ height: 40, maxWidth: 130, objectFit: "contain", border: "1px solid #eee", borderRadius: 6, padding: 3 }} /> : <div style={{ fontSize: 12, color: "#aaa" }}>No logo</div>}
          <label style={{ ...btn, background: "#f0f2f5", color: "#1D1D1F" }} data-testid="report-logo-upload">
            {logo ? "Replace" : "Upload"}
            <input type="file" accept="image/*" onChange={onLogo} style={{ display: "none" }} />
          </label>
          {logo && <button style={{ ...btn, background: "transparent", color: "#ff375f", padding: "9px 6px" }} onClick={() => setLogo(null)} data-testid="report-logo-remove">Remove</button>}
        </div>
        {err && <div style={{ color: "#ff375f", fontSize: 12, marginBottom: 8 }} data-testid="report-details-err">{err}</div>}

        <label style={{ display: "flex", alignItems: "flex-start", gap: 10, cursor: "pointer", border: "1px solid #e3e6ea", borderRadius: 10, padding: "11px 13px", marginTop: 4 }} data-testid="report-include-costing-row">
          <input type="checkbox" checked={includeCosting} onChange={(e) => setIncludeCosting(e.target.checked)} data-testid="report-include-costing" style={{ width: 17, height: 17, marginTop: 1, accentColor: "#51aafe", cursor: "pointer" }} />
          <span>
            <span style={{ fontSize: 13.5, fontWeight: 700, color: "#1D1D1F", display: "block" }}>Include costing &amp; financials page</span>
            <span style={{ fontSize: 11.5, color: "#86868B" }}>CAPEX, OPEX, crop prices, revenue and payback on their own page. Uncheck to omit all cost data from the PDF.</span>
          </span>
        </label>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: 10, marginTop: 18 }}>
          <button style={{ ...btn, background: "transparent", color: "#86868B" }} onClick={onClose} data-testid="report-details-cancel">Cancel</button>
          <button style={{ ...btn, background: "#1D1D1F", color: "#fff" }} onClick={save} data-testid="report-details-save">Save</button>
        </div>
      </div>
    </div>
  );
}
